import { ChatWidgetTroubleshootingAction } from '../actions/ChatWidgetTroubleshootingActions';
import { ChatWidgetTroubleshootingState } from '../interfaces/chatWidgetTroubleshooting';

export const chatWidgetTroubleshooting = (
  state = {},
  action: ChatWidgetTroubleshootingAction,
): ChatWidgetTroubleshootingState => {
  switch (action.type) {
    case 'CHATWIDGETTROUBLESHOOTING__CLEAR':
      return { ...state, lastResult: undefined, lastResultTime: undefined };
    case 'CHATWIDGETTROUBLESHOOTING__RUN':
      return {
        ...state,
        lastResult: action.result,
        lastResultTime: new Date(),
      };
    case 'CHATWIDGETTROUBLESHOOTING__NO_ISSUES_MOUNT': {
      return {
        ...state,
        noIssues: true,
      };
    }
    case 'CHATWIDGETTROUBLESHOOTING__NO_ISSUES_UNMOUNT': {
      return {
        ...state,
        noIssues: false,
      };
    }
    default:
      return state;
  }
};
